export default __webpack_public_path__ + "static/media/AvenueX-Regular.46179a85.otf";